import { AxiosPromise } from 'axios';
import { instance } from '../../../../services';

const deleteVisitorAgreement = (id: number): AxiosPromise =>
  instance.delete(`/api/visitorAgreements/${id}`);

export default deleteVisitorAgreement;
